import styled, { css } from 'styled-components'
import { padding, PaddingProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_MAX_CONTENT_WIDTH_PX } from 'Constants/Landing'

const shouldForwardProp = (prop: string | number) => {
  return ![DIV_SHOULD_FORWARD_PROP, 'asCard'].includes(String(prop))
}

export type ContainerProps = PaddingProps & {
  asCard?: boolean
  noOverflowY?: boolean
}

const containerAsCard = ({ asCard }: ContainerProps) =>
  asCard &&
  css`
    background-color: ${themeGet('colors.surface.block')};

    @media screen and (min-width: ${themeGet('breakpoints.5')}) {
      border-radius: 40px;
    }
  `

const containerNoOverflowY = ({ noOverflowY }: ContainerProps) =>
  noOverflowY &&
  css`
    overflow-y: hidden;
    overflow-x: visible;
  `

export const Container = styled.section.withConfig({
  shouldForwardProp,
})<ContainerProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: ${LANDING_MAX_CONTENT_WIDTH_PX}px;

  ${containerAsCard}
  ${containerNoOverflowY}

  ${padding}
`
